var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-row',[_c('el-col',{attrs:{"md":24,"lg":24}},[_c('sharers-chart',{attrs:{"sharer-data":_vm.sharers}})],1),_vm._v(" "),(_vm.showWays)?_c('el-col',{attrs:{"md":24,"lg":_vm.showWays ? 24 : 0}},[_c('ways-table',{attrs:{"sharer-data":_vm.sharers}})],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }